import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { routerActions } from "react-router-redux/actions";
import { func, shape, boolean } from "prop-types";
import { channelsSelectors } from "reducers/administration";
import { channelsTicketActions } from "reducers/administration/advanced";
import ChannelsTicket from "pages/administration/_components/ChannelsTicket";
import AdministrationTicket from "pages/administration/_components/tickets/AdministrationTicket";
import PageLoading from "pages/_components/PageLoading";

class ChannelsTicketContent extends Component {
    static propTypes = {
        actions: func.isRequired,
        match: shape({}).isRequired,
        fetching: boolean,
    };

    static defaultProps = {
        fetching: true,
    };

    componentDidMount() {
        const { actions, match } = this.props;
        actions.loadChannelsTicketRequest(match.params.idTransaction);
    }

    render() {
        const { fetching } = this.props;

        return (
            <PageLoading loading={fetching}>
                <AdministrationTicket {...this.props}>
                    <ChannelsTicket {...this.props} />
                </AdministrationTicket>
            </PageLoading>
        );
    }
}

const mapStateToProps = (state) => ({
    user: channelsSelectors.getUser(state),
    fetching: channelsSelectors.isFetching(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(channelsTicketActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChannelsTicketContent);
